import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/list-type/all`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        const obj = response.data;
        if (Object.keys(obj["listTypes"]).length > 0) {
          store.dispatch("entities/listTypes/create", {
            data: obj["listTypes"]
          });
        }
        if (Object.keys(obj["listItems"]).length > 0) {
          store.dispatch("entities/listItems/create", {
            data: obj["listItems"]
          });
        }
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async createListType(context, listType) {
      if (listType.isDirty === true) {
        const store = this;
        try {
          const accountId = store.getters["entities/listTypes/find"](1).id;
          let newListTypeData = {
            accountId: accountId,
            name: listType.name
          };
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/list-type`,
            data: newListTypeData,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          let updateListType = {
            id: response.data.id,
            name: response.data.name,
            system: false
          };
          store.dispatch("entities/listTypes/insert", {
            where: response.data.id,
            data: updateListType
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateListType(context, listType) {
      const store = this;
      let oldListType = store.getters["entities/listTypes/find"](listType.id);
      if (!(oldListType.name === listType.name) || listType.isDirty === true) {
        try {
          const accountId = store.getters["entities/accounts/query"]().first().id;
          let newListTypeData = {
            id: listType.id,
            accountId: accountId,
            name: listType.name
          };
          store.dispatch("entities/listTypes/update", newListTypeData);
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/list-type/${newListTypeData.id}`,
            data: newListTypeData,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          let updateListType = {
            name: response.data.name,
            system: false
          };
          store.dispatch("entities/listTypes/update", {
            where: response.data.id,
            data: updateListType
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async deleteListItem(context, listType) {
      const store = this;
      store.dispatch("entities/listTypes/delete", listType.id);
      if (listType.isDirty === true) {
        try {
          const accountId = store.getters["entities/accounts/query"]().first().id;
          await axios({
            method: "patch",
            url: API_BASE_URL + `/list-type/${listType.id}`,
            data: {
              accountId: accountId,
              id: listType.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};
